var map = {
	"./BDJ.png": "./src/assets/yundong/BDJ.png",
	"./DGCX.png": "./src/assets/yundong/DGCX.png",
	"./DSWS.png": "./src/assets/yundong/DSWS.png",
	"./FYTT.png": "./src/assets/yundong/FYTT.png",
	"./GYJB.png": "./src/assets/yundong/GYJB.png",
	"./KQJD.png": "./src/assets/yundong/KQJD.png",
	"./KZ.png": "./src/assets/yundong/KZ.png",
	"./MC.png": "./src/assets/yundong/MC.png",
	"./SB.png": "./src/assets/yundong/SB.png",
	"./TJQ.png": "./src/assets/yundong/TJQ.png",
	"./TLDLS.png": "./src/assets/yundong/TLDLS.png",
	"./WQX.png": "./src/assets/yundong/WQX.png",
	"./YJJ.png": "./src/assets/yundong/YJJ.png",
	"./YY.png": "./src/assets/yundong/YY.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/yundong sync recursive ^\\.\\/.*\\.png$";